import { useQuery } from 'react-query';
import { FirebaseContext } from '../../../context/FirebaseContext';
import { getQuestionnairPercentageAnalysis } from '../../../NecttosComp/APICaller/ApiServices';
import Button from '../../../NecttosComp/Button/Button';
import React, { useContext, useState } from 'react';
import { Body, Header, Main } from '../../../NecttosComp/Layout/Layout';
import { useTheme } from '../../../context/ThemeContext.js.js';

export const FeedbackStatistics = ({ onClose, questionnaireId }) => {
	const { collegeId } = useContext(FirebaseContext);
	const { theme } = useTheme();
	const [state, setState] = useState({});

	const { data: allData = {}, refetch } = useQuery(
		['getQuestionnairPercentatgeAnalysis', collegeId, questionnaireId],
		getQuestionnairPercentageAnalysis(collegeId, questionnaireId)
	);

	const getBarData = () => {
		if (state?.subDataData && Array.isArray(state.subData)) return state.subData;
		if (state?.intividualData && Array.isArray(state.dataData)) return state.dataData;
		if (Array.isArray(allData?.departmentData)) return allData.departmentData;
		return [];
	};

	const handleBarClick = (item) => {
		const isSubData = !!state?.subDataData;
		const isIndividualData = !!state?.intividualData;

		if (isSubData) {
			setState({
				...state,
				intividualData: false,
				subDataData: false,
				deptBack: false,
				classBack: false,
				departmentName: '',
				verified: '',
				unverified: '',
				verified2: '',
				unverified2: '',
			});
		} else if (isIndividualData) {
			setState({
				...state,
				deptBack: false,
				classBack: true,
				intividualData: false,
				subDataData: true,
				dataData: item.data,
				verified2: item.percentage,
				unverified2: item.percentage,
				departmentName: item.title,
			});
		} else {
			setState({
				...state,
				deptBack: true,
				classBack: false,
				intividualData: true,
				dataData: item.data,
				verified: item.percentage,
				unverified: item.percentage,
				departmentName: item.title,
			});
		}
	};

	const barData = getBarData();
	const validBars = barData.filter((item) => typeof item.percentage === 'number');
	const totalDataPercentage = validBars.length ? validBars.reduce((acc, item) => acc + item.percentage, 0) / validBars.length : 0;

	return (
		<Main title='Feedback Statistics' height='100%' width='100%'>
			<Header>
				<div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 w-full'>
					{/* <div className='text-base sm:text-xl font-bold tracking-wide text-center sm:text-left text-slate-800 dark:text-white'>
						{state.departmentName?.toUpperCase() || 'STUDENTS'} PROFILE STATISTICS
					</div> */}
					<div className='flex flex-wrap gap-2 justify-center sm:justify-end'>
						<Button onClick={refetch} type='search' className='bg-slate-200 hover:bg-slate-300 text-slate-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white'>
							Refresh
						</Button>
						<Button type='close' onClick={onClose} className='bg-slate-100 hover:bg-slate-200 text-slate-700 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white'>
							Close
						</Button>
					</div>
				</div>
			</Header>

			<Body height='100%'>
				<div className={`flex flex-col h-full rounded-2xl overflow-hidden shadow-md px-4 py-6 sm:p-6 ${theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-white text-slate-800'}`}>
					<div className='flex flex-col sm:flex-row items-center justify-center gap-4 mb-6'>
						<div className='bg-slate-800 dark:bg-emerald-600 text-white text-center rounded-full text-lg sm:text-2xl font-semibold px-6 py-3 min-w-[200px] shadow'>
							Total Data {totalDataPercentage.toFixed(2)}%
						</div>

						{state?.deptBack && (
							<Button
								type='edit'
								onClick={() =>
									setState((prev) => ({
										...prev,
										intividualData: false,
										subDataData: false,
										deptBack: false,
										classBack: false,
										verified: '',
										unverified: '',
									}))
								}
								className='bg-slate-100 hover:bg-slate-200 text-slate-700 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white'>
								Back
							</Button>
						)}

						{state?.classBack && (
							<Button
								type='edit'
								onClick={() =>
									setState((prev) => ({
										...prev,
										intividualData: true,
										deptBack: true,
										classBack: false,
										subDataData: false,
										subData: [],
										verified2: '',
										unverified2: '',
									}))
								}
								className='bg-slate-100 hover:bg-slate-200 text-slate-700 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white'>
								Back
							</Button>
						)}
					</div>

					<div className='flex-1 overflow-x-auto'>
						<div className={`border rounded-xl shadow-inner p-4 min-w-[600px] overflow-auto ${theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-slate-200'}`}>
							<div className='h-[50vh] w-full flex items-end justify-start sm:justify-center gap-8 pb-6 px-2'>
								{barData.map((item, index) => {
									const label = item.title || item.name || `Item ${index + 1}`;
									const percentage = Math.max(item.percentage || 0, 0);
									const maxBarHeight = 200;
									const barHeight = Math.max((percentage / 100) * maxBarHeight, 4);

									return (
										<div key={index} onClick={() => handleBarClick(item)} className='relative group cursor-pointer w-12 sm:w-14 text-center'>
											<div className='flex flex-col items-center h-full justify-end'>
												<div className='mb-4 text-xs font-bold text-slate-800 dark:text-white'>{percentage.toFixed(2)}%</div>
												<div className='w-full bg-slate-700 dark:bg-emerald-500 rounded-t-md group-hover:scale-y-110 transition-transform duration-500 origin-bottom shadow-md' style={{ height: `${barHeight}px` }} />
												<div className='mt-3 text-[11px] text-slate-600 dark:text-slate-300 font-medium leading-tight max-w-[5rem] break-words'>
													{label}
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</Body>
		</Main>
	);
};
